<app-sidebar-header
  title="{{ 'information_about' | translate }} {{ card ? card.name : ('card-old' | translate) }}"
></app-sidebar-header>
@if (cardForm) {
  <div class="p-3 h-100 overflow-auto crm-scroll bg-deal" [formGroup]="cardForm">
    <div class="pb-4">
      <div [ngClass]="{ 'flex-wrap': baseService.isMobile }" class="d-flex flex-row gap-2">
        <div class="d-flex align-items-end">
          <div class="d-flex flex-column mw-300px">
            <!--          <app-hidden-input-->
            <!--            [hidden-input]="card.name"-->
            <!--            [formControl]='cardForm.controls.name'-->
            <!--            [inputHeight]="'36px'"-->
            <!--            placeholder="{{'enter_the_name_of_the' | translate}}"-->
            <!--            (onChangeCancel)="onCancelUpdate()"-->
            <!--            errorText="{{'name_card_cannot_be_empty'| translate}}"-->
            <!--            [isError]="!cardForm.controls.name.value.trim()"-->
            <!--            [isDeactivate]="isAllDeactivate"-->
            <!--            (onChangeClick)="onActiveSomeInput()"-->
            <!--          ></app-hidden-input>-->
          </div>
        </div>
        @if (!baseService.isMobile) {
          <mat-divider vertical class="mx-2"></mat-divider>
        }
        <div class="d-flex align-items-center fs-sm gap-2">
          <app-dropdown
            class="w-funnels-dropdown"
            [items]="funnels"
            [closeOnSelect]="true"
            (onValueChange)="onChangeFunnel($event)"
            [formControl]="cardForm.controls.funnel_id"
            [bindValue]="'id'"
          ></app-dropdown>
          <!--        <hidden-input type="color" (blur)="onUpdate()" [formControl]='cardForm.controls.bg_color'>-->
          <app-color
            class="w-25"
            (onValueChange)="onUpdate()"
            [input]="cardForm.controls.bg_color.value"
            [formControl]="cardForm.controls.bg_color"
            [colors]="colors"
          >
          </app-color>
          <!--        <hidden-input type="color" (ngModelChange)="onUpdateColor()" [formControl]='cardForm.controls.tx_color'>-->
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-4">
      @if (!baseService.isMobile) {
        <div
          [ngClass]="baseService.isMobile ? 'flex-column flex-wrap gap-2' : 'flex-row flex-nowrap'"
          class="d-flex justify-content-start align-items-stretch w-auto"
        >
          @for (column of columns; track column; let i = $index) {
            <div
              class="d-flex flex-column board-column click-css"
              (mouseover)="isHoverArrow(true, column.bg_color, column.text_color, i)"
              (mouseleave)="isHoverArrow(false, column.bg_color, column.text_color, i)"
              (click)="onChangeColumn(column.id)"
            >
              <div
                class="d-flex justify-content-between align-items-center position-relative pointer transition"
                [ngStyle]="columnStyle(column, i)"
              >
                <span class="text-ellipsis ps-2">{{ column?.name }}</span>
              </div>
            </div>
          }
        </div>
      }
      @if (baseService.isMobile) {
        <app-dropdown
          [items]="columns"
          [bindValue]="'id'"
          [closeOnSelect]="true"
          [input]="$safeNavigationMigration(currentColumn?.id)"
          (onValueChange)="onChangeColumn($event)"
        ></app-dropdown>
      }
      <div class="w-fc">
        <app-tabs [tabList]="tabs" (onSelectTab)="onChangeTab($event)" />
      </div>
      <div [ngClass]="baseService.isMobile ? 'd-flex flex-wrap' : ''" class="d-flex gap-4">
        <div [ngClass]="baseService.isMobile ? 'w-100 d-flex flex-wrap' : 'w-35'">
          <div class="d-flex flex-column gap-2 w-100">
            <div>
              <mat-card class="p-3 shadow-sm border">
                <mat-card-header class="p-0">
                  <span class="fs-sm fw-bold text-darkgray text-uppercase">{{ 'about_deal' | translate }}</span>
                </mat-card-header>
                <mat-divider class="my-2"></mat-divider>
                <mat-card-content class="d-flex flex-column gap-3 p-0">
                  <div class="d-flex flex-column">
                    <div>
                      <span class="fs-sm text-darkgray">{{ 'phase' | translate }}</span>
                    </div>
                    <span class="fs-md text-dark">{{ currentColumn?.name }}</span>
                  </div>
                  <div class="d-flex flex-column">
                    <div>
                      <span class="fs-sm text-darkgray">{{ 'amount_and_currency' | translate }}</span>
                    </div>
                    <div class="d-flex flex-row align-items-center gap-2">
                      <!--                    <app-hidden-input-->
                      <!--                      [mask]="'separator.2'"-->
                      <!--                      [generalText]="card.price.toLocaleString('en-US', { minimumFractionDigits: 2 })"-->
                      <!--                      [hidden-input]="card.price"-->
                      <!--                      [formControl]='cardForm.controls.price'-->
                      <!--                      [inputHeight]="'36px'"-->
                      <!--                      [placeholder]="'enter_price' | translate"-->
                      <!--                      (onChangeCancel)="onCancelUpdate()"-->
                      <!--                      [isError]="cardForm.controls.price.status === 'INVALID'"-->
                      <!--                      [isDeactivate]="isAllDeactivate"-->
                      <!--                      (onChangeClick)="onActiveSomeInput()"-->
                      <!--                      style="max-width: 70%"-->
                      <!--                    ></app-hidden-input>-->
                      <app-dropdown
                        bindLabel="name"
                        bindValue="value"
                        [items]="CURRENCY"
                        [closeOnSelect]="true"
                        [formControl]="cardForm.controls.currency"
                        (onValueChange)="onUpdate()"
                      ></app-dropdown>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div>
                      <span class="fs-sm text-darkgray">{{ 'сomment' | translate }}</span>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                      <mat-card class="shadow-sm border w-100">
                        <mat-card-content class="p-0 shadow-none">
                          <mat-form-field appearance="outline" class="ticket-field w-100">
                            <textarea
                              class="no-resize crm-scroll w-100"
                              [formControl]="cardForm.controls.comment"
                              matInput
                              (ngModelChange)="onActiveSomeInput()"
                            >
                            </textarea>
                          </mat-form-field>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </div>
                  @if (cardCAForm) {
                    <ng-container [formGroup]="cardCAForm">
                      @for (field of customAttributes; track field) {
                        <div class="d-flex flex-column">
                          @if (field.is_view) {
                            @if (!['checkbox'].includes(field.type)) {
                              <div>
                                <span class="fs-sm text-darkgray">{{ field.title }}</span>
                              </div>
                            }
                            @if (field.type === 'link') {
                              <div>
                                <!--                        <app-hidden-input-->
                                <!--                          [formControlName]="field.key"-->
                                <!--                          [type]="'link'"-->
                                <!--                          [inputHeight]="'36px'"-->
                                <!--                          [placeholder]="'enter_link' | translate"-->
                                <!--                          (onChangeCancel)="onCancelUpdate()"-->
                                <!--                          (onChangeSave)="onSaveUpdateCA(field.key, $event)"-->
                                <!--                          [isError]="!cardCAForm.valid"-->
                                <!--                          [isDeactivate]="isAllDeactivate"-->
                                <!--                          (onChangeClick)="onActiveSomeInput()"-->
                                <!--                        ></app-hidden-input>-->
                              </div>
                            }
                            @if (field.type === 'text') {
                              <div>
                                <!--                        <app-hidden-input-->
                                <!--                          [formControlName]="field.key"-->
                                <!--                          [type]="'text'"-->
                                <!--                          [inputHeight]="'36px'"-->
                                <!--                          [placeholder]="'enter_text' | translate"-->
                                <!--                          (onChangeCancel)="onCancelUpdate()"-->
                                <!--                          (onChangeSave)="onSaveUpdateCA(field.key, $event)"-->
                                <!--                          [isError]="!cardCAForm.valid"-->
                                <!--                          [isDeactivate]="isAllDeactivate"-->
                                <!--                          (onChangeClick)="onActiveSomeInput()"-->
                                <!--                        ></app-hidden-input>-->
                              </div>
                            }
                            @if (field.type === 'textarea') {
                              <div>
                                <!--                        <app-hidden-input-->
                                <!--                          [(active)]="field.is_active"-->
                                <!--                          [formControlName]="field.key"-->
                                <!--                          [type]="'textarea'"-->
                                <!--                          [inputHeight]="'64px'"-->
                                <!--                          [placeholder]="'enter_text' | translate"-->
                                <!--                          (onChangeCancel)="onCancelUpdate()"-->
                                <!--                          (onChangeSave)="onSaveUpdateCA(field.key, $event)"-->
                                <!--                          [isError]="!cardCAForm.valid"-->
                                <!--                          [isDeactivate]="isAllDeactivate"-->
                                <!--                          (onChangeClick)="onActiveSomeInput()"-->
                                <!--                        ></app-hidden-input>-->
                              </div>
                            }
                            @if (field.type === 'checkbox') {
                              <div>
                                <app-checkbox [formControlName]="field.key" (change)="onActiveSomeInput()">
                                  {{ field.title }}
                                </app-checkbox>
                              </div>
                            }
                          }
                        </div>
                      }
                    </ng-container>
                  }
                  <div class="d-flex flex-column">
                    <div>
                      <span class="fs-sm text-darkgray">{{ 'created_at' | translate }}:</span>
                    </div>
                    <div class="d-flex align-items-end flex-row gap-2 text-center">
                      <span class="fs-md text-dark">{{ card.created_at | date: 'dd MMMM YYYY' }}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="my-2">
              <mat-card class="p-3 shadow-sm border">
                <mat-card-header class="p-0">
                  <span class="fs-sm fw-bold text-darkgray text-uppercase">{{ 'contacts' | translate }}</span>
                </mat-card-header>
                <mat-divider class="my-2"></mat-divider>
                @if (currentContact) {
                  <mat-card-content class="p-0 shadow-none">
                    <div class="d-flex flex-row justify-content-between">
                      <div class="d-flex flex-column align-self-center">
                        @if (!isContactCreate) {
                          <span class="fs-sm text-secondary">{{ 'contact' | translate }}</span>
                        }
                        @if (!isContactUpdate) {
                          <p class="fs-md text-crm">
                            {{ currentContact?.name }}
                          </p>
                          @for (contactInfo of contactInfoList; track contactInfo) {
                            @if (_filter(contactInfo.items).length !== 0) {
                              @for (item of contactInfo.items; track item; let isFirst = $first) {
                                <div class="d-flex align-items-center flex-row gap-2">
                                  @if (isFirst) {
                                    <app-icon class="fs-6 w-unset text-secondary">
                                      {{ contactInfo.icon }}
                                    </app-icon>
                                  }
                                  @if (!isFirst) {
                                    <div class="flex-fill"></div>
                                  }
                                  <span
                                    class="d-flex align-items-center align-self-baseline fs-sm text-secondary w-100"
                                    >{{ item }}</span
                                  >
                                </div>
                              }
                            }
                          }
                          <div class="mt-2">
                            <span class="fs-sm text-secondary">
                              {{ $safeNavigationMigration(currentContact?.created_at) | date: 'EE, dd MMMM YYYY' }}
                            </span>
                          </div>
                        }
                      </div>
                      @if (!isContactUpdate) {
                        <div class="align-self-end">
                          <div class="d-flex flex-column gap-2 ms-3">
                            <app-button
                              [btnType]="'no-border'"
                              [customClass]="'shadow-sm bg-primary p-0'"
                              (onChangeClick)="onContactChanges(false, true)"
                            >
                              <app-icon class="fs-6 h-unset w-unset text-white"> edit </app-icon>
                            </app-button>
                            <app-button
                              [btnType]="'no-border'"
                              [customClass]="'shadow-sm bg-danger p-0'"
                              (onChangeClick)="onDeleteContact()"
                            >
                              <app-icon class="fs-6 h-unset w-unset text-white"> delete </app-icon>
                            </app-button>
                          </div>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                }
                @if (isContactUpdate || isContactSelect) {
                  <div class="d-flex flex-column gap-2" [formGroup]="contactForm">
                    @if (!isContactCreate) {
                      <app-dropdown
                        [items]="contacts"
                        [bindValue]="'id'"
                        [closeOnSelect]="true"
                        [input]="(card && card.contact_id) ?? null"
                        (onValueChange)="onChangeContact($event)"
                        [isHasActions]="true"
                        [actions]="contactActions"
                        (onActionClick)="onCreateContactForm()"
                        [formControl]="contactForm.controls.contact_id"
                        [placeholder]="'select_contact' | translate"
                        (onScrollDropdown)="scrollToEndContacts()"
                        [searchable]="true"
                        (onSearchDropdown)="searchContact($event)"
                        [notFoundText]="'contact_not_found' | translate"
                        (close)="onCloseDropdown()"
                      ></app-dropdown>
                    }
                    @if (isContactCreate || isContactUpdate) {
                      <div>
                        <app-text-field
                          [label]="'pip' | translate"
                          [formControl]="contactForm.controls.name"
                          [placeholder]="'enter_pip' | translate"
                          [error]="contactForm.controls.name.invalid && !contactForm.controls.name.untouched"
                        ></app-text-field>
                        <app-phone-field
                          [label]="'phone' | translate"
                          [formControl]="contactForm.controls.phone"
                          placeholder="{{ 'enter_phone_number' | translate }}"
                          [error]="contactForm.controls.phone.invalid"
                        ></app-phone-field>
                        <app-text-field
                          [label]="'mail' | translate"
                          [formControl]="contactForm.controls.email"
                          placeholder="{{ 'enter_your_e-mail' | translate }}"
                          [error]="contactForm.controls.email.invalid"
                        ></app-text-field>
                        <app-google-address-textfield
                          [label]="'address' | translate"
                          [formControl]="contactForm.controls.address"
                          placeholder="{{ 'enter_the_address' | translate }}"
                        ></app-google-address-textfield>
                      </div>
                    }
                    <div class="d-flex justify-content-between gap-2 mt-2">
                      @if (!isContactCreate) {
                        <app-button (onChangeClick)="onSaveContact()">{{ 'save' | translate }}</app-button>
                      }
                      @if (isContactCreate) {
                        <app-button (onChangeClick)="onSaveContact()">{{ 'assign_and_save' | translate }}</app-button>
                      }
                      <app-button (onChangeClick)="onCloseContact(isContactCreate)" [btnType]="'stroked'"
                        >{{ 'cancel' | translate }}
                      </app-button>
                    </div>
                  </div>
                }
                @if (!currentContact && !isContactUpdate && !isContactCreate && !isContactSelect) {
                  <mat-card-content>
                    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-4">
                      <span class="text-center">
                        {{ 'no_one_contact' | translate }}
                      </span>
                      <app-button
                        [full]="true"
                        [btnType]="'no-border'"
                        class="w-100"
                        [customClass]="'shadow-sm bg-white'"
                        (onChangeClick)="onContactChanges(true)"
                      >
                        <app-icon class="text-secondary"> add </app-icon>
                      </app-button>
                    </div>
                  </mat-card-content>
                }
              </mat-card>
            </div>
          </div>
        </div>
        @if (card && funnel) {
          <div [ngClass]="baseService.isMobile ? 'w-100' : 'w-75'">
            <app-activity [entityUuid]="card.id" [entityType]="funnel.type"></app-activity>
          </div>
        }
      </div>
    </div>
    @if (isActiveSomeInput) {
      <div class="z-1 bottom-0 d-flex gap-2 bg-white w-100 p-2">
        <app-button (onChangeClick)="onCancelUpdate()">{{ 'cancel' | translate }}</app-button>
        <app-button (onChangeClick)="onUpdate()" [disabled]="!isHasChange || cardCAForm.invalid || cardForm.invalid">{{
          'save' | translate
        }}</app-button>
      </div>
    }
  </div>
}
